import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DealerProfileService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getProfiles(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealer-profile/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getProfile(profileId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealer-profile/' + profileId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageProfile(profile, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/dealer-profile/' + id, profile)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/dealer-profile/', profile)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/dealer-profile/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public deleteProfile(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/dealer-profile/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  updateDealerProfile(value, id) {
    return this.http.put(environment.apiUrl + '/backoffice/dealer-profile/' + id + '/change-profile', {dealerProfiles: value})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
